import { Empty } from '@src/@data/utility/NotImplemented';
import {
  useState,
  useEffect,
  createContext,
  useContext,
  useCallback,
} from 'react';

interface PrintingContextType {
  isPrinting: boolean;
  setIsPrinting: (isPrinting: boolean) => void;
  saveAsPdf: () => void;
}

const PrintingContext = createContext<PrintingContextType>({
  isPrinting: false,
  setIsPrinting: Empty,
  saveAsPdf: Empty,
});

export const useIsPrinting = () => useContext(PrintingContext);

export const PrintingProvider: React.FC = ({ children }) => {
  const [isPrinting, setIsPrinting] = useState(false);

  const handleAfterPrint = () => setIsPrinting(false);

  const saveAsPdf = useCallback(() => {
    setIsPrinting(true);
    // hack to allow changing printing state before DOM freeze
    window.setTimeout(() => {
      window.print();
    }, 1000);
  }, [setIsPrinting]);

  useEffect(() => {
    window.addEventListener('afterprint', handleAfterPrint);
    return () => {
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, []);

  return (
    <PrintingContext.Provider value={{ isPrinting, setIsPrinting, saveAsPdf }}>
      {children}
    </PrintingContext.Provider>
  );
};
